import React from "react";
import { FaCalendar, FaInfo, FaInstagram, FaYoutube } from "react-icons/fa6";
import { FiFacebook, FiTwitter, FiYoutube } from "react-icons/fi";
import { TbMathGreater } from "react-icons/tb";
import { Link, useLocation } from "react-router-dom";
import { FacebookShareButton, TwitterShareButton, LinkedinShareButton, FacebookIcon, TwitterIcon, LinkedinIcon, FacebookMessengerShareButton, FacebookMessengerIcon, WhatsappShareButton, WhatsappIcon, TelegramShareButton, TelegramIcon, PinterestShareButton, PinterestIcon, RedditShareButton, RedditIcon, EmailShareButton, EmailIcon } from 'react-share';


const TailwindFooter = () => {


  // Share here

  const location = useLocation();
  const shareUrl = window.location.origin + location.pathname + location.search;

  // console.log(shareUrl); // Logs the current URL (e.g., https://yourwebsite.com/details/123?query=param)




  return (
    <div className="relative md:top-[190px] top-[-16px]">
      <footer className="bg-white">
        <div className="max-w-screen-xl px-4 pt-16 pb-6 mx-auto sm:px-6 lg:px-8 lg:pt-24">
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
            <div>
              <div className="flex flex-col justify-center text-teal-300 sm:justify-start">
                <div className="footer-logo">
                  <Link to="/">
                    <img
                      style={{ width: "200px", height: "150px" }}
                      src="/image/fly-inn-logo.svg"
                      alt=""
                    />
                  </Link>
                </div>
                <div className="footer-contacts-widget fl-wrap">
                  <p style={{ color: "#3B4249", marginLeft: "-8px" }}>
                    We empower aviation enthusiasts to book and host lodging,
                    transportation and more!
                  </p>

                  <div className="flex-wrap items-center gap-3 p-3 space-x-4 bg-white rounded d-flex">
                    <div>

                      <h3 className="title"> Share us on : </h3>
                    </div>
                    <div className="flex-wrap gap-4 flex-column d-flex !ml-0">
                      {/* Facebook Share Button */}
                      <FacebookShareButton url={'https://web.facebook.com/FlyInnLLC/'} quote="Check this out!" // Optional: Add a custom quote
                        hashtag={`Check our our growing inventory…growing daily all over North America.`} title={'Fly-Inn'} className="flex items-center justify-center p-3 text-white transition bg-blue-600 rounded-full hover:bg-blue-700">
                        <FacebookIcon size={32} round />
                      </FacebookShareButton>

                      <a
                        href="https://www.instagram.com/flyinnllc/" // Link to Instagram (you can customize this)
                        target="_blank" // Open in a new tab
                        rel="noopener noreferrer" // Security best practice
                        className="flex items-center justify-center p-3 text-orange-600 transition rounded-full "
                      >
                        <FaInstagram size={32} round />
                      </a>


                      <a
                        href="https://www.youtube.com/@Fly-Inn/" // Link to Instagram (you can customize this)
                        target="_blank" // Open in a new tab
                        rel="noopener noreferrer" // Security best practice
                        className="flex items-center justify-center text-orange-600 transition rounded-full "
                      >
                        <FaYoutube size={32} round />
                      </a>

                      <FacebookMessengerShareButton url={shareUrl} title={'Fly-Inn'} className="flex items-center justify-center p-3 text-white transition bg-blue-700 rounded-full hover:bg-blue-800">
                        <FacebookMessengerIcon size={32} round />
                      </FacebookMessengerShareButton>


                      {/* Twitter Share Button */}
                      <TwitterShareButton url={'https://twitter.com/FlyInnLLC'} title={'Fly-Inn'} className="flex items-center justify-center p-3 text-white transition bg-blue-400 rounded-full hover:bg-blue-500">
                        <TwitterIcon size={32} round />
                      </TwitterShareButton>

                      {/* LinkedIn Share Button */}
                      <LinkedinShareButton url={shareUrl} title={'Fly-Inn'} className="flex items-center justify-center p-3 text-white transition bg-blue-700 rounded-full hover:bg-blue-800">
                        <LinkedinIcon size={32} round />
                      </LinkedinShareButton>

                      <WhatsappShareButton url={shareUrl} title={'Fly-Inn'} className="flex items-center justify-center p-3 text-white transition bg-blue-700 rounded-full hover:bg-blue-800">
                        <WhatsappIcon size={32} round />
                      </WhatsappShareButton>

                      <TelegramShareButton url={shareUrl} title={'Fly-Inn'} className="flex items-center justify-center p-3 text-white transition bg-blue-700 rounded-full hover:bg-blue-800">
                        <TelegramIcon size={32} round />
                      </TelegramShareButton>

                      <PinterestShareButton url={shareUrl} title={'Fly-Inn'} className="flex items-center justify-center p-3 text-white transition bg-blue-700 rounded-full hover:bg-blue-800">
                        <PinterestIcon size={32} round />
                      </PinterestShareButton>

                      <RedditShareButton url={shareUrl} title={'Fly-Inn'} className="flex items-center justify-center p-3 text-white transition bg-blue-700 rounded-full hover:bg-blue-800">
                        <RedditIcon size={32} round />
                      </RedditShareButton>

                      <EmailShareButton url={shareUrl} title={'Fly-Inn'} className="flex items-center justify-center p-3 text-white transition bg-blue-700 rounded-full hover:bg-blue-800">
                        <EmailIcon size={32} round />
                      </EmailShareButton>
                    </div>
                  </div>


                  <div className="flex-wrap items-center gap-3 p-3 space-x-4 bg-white rounded d-flex">
                    <div>

                      <h3 className="title"> Find us on : </h3>
                    </div>
                    <div className="flex-wrap gap-4 flex-column d-flex !ml-0">
                      {/* Facebook Share Button */}
                      <FacebookShareButton url={'https://web.facebook.com/FlyInnLLC/'} quote="Check this out!" // Optional: Add a custom quote
                        hashtag={`Check our our growing inventory…growing daily all over North America.`} title={'Fly-Inn'} className="flex items-center justify-center p-3 text-white transition bg-blue-600 rounded-full hover:bg-blue-700">
                        <FacebookIcon size={32} round />
                      </FacebookShareButton>

                      {/* Twitter Share Button */}
                      <TwitterShareButton url={shareUrl} title={'Fly-Inn'} className="flex items-center justify-center p-3 text-white transition bg-blue-400 rounded-full hover:bg-blue-500">
                        <TwitterIcon size={32} round />
                      </TwitterShareButton>

                      <a
                        href="https://www.instagram.com/flyinnllc/" // Link to Instagram (you can customize this)
                        target="_blank" // Open in a new tab
                        rel="noopener noreferrer" // Security best practice
                        className="flex items-center justify-center p-3 text-orange-600 transition rounded-full "
                      >
                        <FaInstagram size={32} round />
                      </a>


                      <a
                        href="https://www.youtube.com/@Fly-Inn/" // Link to Instagram (you can customize this)
                        target="_blank" // Open in a new tab
                        rel="noopener noreferrer" // Security best practice
                        className="flex items-center justify-center text-orange-600 transition rounded-full "
                      >
                        <FaYoutube size={32} round />
                      </a>


                      <LinkedinShareButton url={shareUrl} title={'Fly-Inn'} className="flex items-center justify-center p-3 text-white transition bg-blue-700 rounded-full hover:bg-blue-800">
                        <LinkedinIcon size={32} round />
                      </LinkedinShareButton>

                      <PinterestShareButton url={shareUrl} title={'Fly-Inn'} className="flex items-center justify-center p-3 text-white transition bg-blue-700 rounded-full hover:bg-blue-800">
                        <PinterestIcon size={32} round />
                      </PinterestShareButton>

                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:col-span-2 md:grid-cols-3">
              <div className="footer-widget fl-wrap">
                <h3>Our Latest Posts</h3>
                <div className="footer-widget-posts fl-wrap">
                  <ul className="no-list-style !pl-0">
                    <li className="clearfix">
                      <Link to="#" className="widget-posts-img">
                        <img
                          src="https://fly-inn.com/wp-content/uploads/2024/12/Untitled-design-2-120x80.png"
                          className="respimg"
                          alt=""
                        />
                      </Link>
                      <div className="widget-posts-descr">
                        <Link className="h-btn" to="https://fly-inn.com/4-promises-fly-inn-com-hosts-make-because-pilots-deserve-to-be-pampered-too" title="">
                          4 Promises Fly-Inn.com Hosts Make
                        </Link>
                        <span
                          style={{ color: "#4f5962" }}
                          className="widget-posts-date"
                        >
                          <i
                            style={{ color: "#4f5962" }}
                            className="fal fa-calendar"
                          />{" "}
                          2 months ago by PIC
                        </span>
                      </div>
                    </li>
                    <li className="clearfix">
                      <Link to="#" className="widget-posts-img">
                        <img
                          src="https://fly-inn.com/wp-content/uploads/2023/11/oshkosh-entrance-1440x810-sh-2211818629-120x80.webp"
                          className="respimg"
                          alt=""
                        />
                      </Link>
                      <div className="widget-posts-descr">
                        <Link className="h-btn" to="https://fly-inn.com/the-most-fun-fly-ins-in-america" title="">
                          {" "}
                          The Most Fun Fly-Ins in America
                        </Link>
                        <span
                          style={{ color: "#4f5962" }}
                          className="widget-posts-date"
                        >
                          <i
                            style={{ color: "#4f5962" }}
                            className="fal fa-calendar"
                          />{" "}
                          1 year ago by PIC
                        </span>
                      </div>
                    </li>
                    <li className="clearfix">
                      <Link to="#" className="widget-posts-img">
                        <img
                          src="https://fly-inn.com/wp-content/uploads/2018/11/air_show_3240975_1140X760_blog-120x80.jpg"
                          className="respimg"
                          alt=""
                        />
                      </Link>
                      <div className="widget-posts-descr">
                        <Link className="h-btn" to="https://fly-inn.com/11-most-popular-air-shows-in-the-united-states" title="">
                          11 Most Popular Air Shows in the United States
                        </Link>
                        <span
                          style={{ color: "#4f5962" }}
                          className="widget-posts-date"
                        >
                          <i
                            style={{ color: "#4f5962" }}
                            className="fal fa-calendar"
                          />{" "}
                          1 year ago by PIC
                        </span>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="footer-widget fl-wrap">
                <h3>Company</h3>
                <div className="footer-widget-posts fl-wrap">
                  <ul className="footer-list fl-wrap !list-none flex flex-col !pl-0">
                    <li className="!flex gap-1 list-none items-center">
                      <FaInfo className="font-medium text-md" />  <Link to="/about">About</Link>
                    </li>

                  </ul>
                </div>
              </div>
              <div className="footer-widget fl-wrap ">
                <h3 className="font-bold">Contact us</h3>
                <ul className="footer-contacts fl-wrap no-list-style !pl-0">
                  <li className="!rounded-none border-b border-gray-200 pb-2">
                    {" "}
                    <span>
                      <i
                        style={{ color: "#4f5962" }}
                        className="fal fa-map-marker"
                      />
                    </span>
                    <Link className="h-btn" to="#">
                      P.O. Box 270439, Fruitland, UT 84027
                    </Link>
                  </li>
                  <li className="!rounded-none border-b border-gray-200 pb-2">
                    <span>
                      <i
                        style={{ color: "#4f5962" }}
                        className="fal fa-phone"
                      />
                    </span>
                    <Link className="h-btn" to="#">
                      {" "}
                      833-I-Fly-Inn
                    </Link>
                  </li>
                  <li className="!rounded-none border-b border-gray-200 pb-2">
                    {" "}
                    <span>
                      <i
                        style={{ color: "#4f5962" }}
                        className="fal fa-phone"
                      />
                    </span>
                    <Link className="h-btn" to="#">
                      321-I-Fly-Inn
                    </Link>
                  </li>
                  <li className="!rounded-none border-b border-gray-200 pb-2">
                    <span>
                      <i
                        style={{ color: "#4f5962" }}
                        className="fal fa-envelope"
                      />
                    </span>

                    <Link className="h-btn" to="mailto:PIC@Fly-Inn.com">
                      <span className="footer_link_changes">
                        {" "}
                        PIC@Fly-Inn.com
                      </span>
                    </Link>
                  </li>
                  <li className="!rounded-none border-b border-gray-200 pb-2"
                    style={{ display: "flex", alignItems: "center" }}
                    onClick={() => window.scrollTo({ top: 0 })}
                  >
                    <Link className="flex h-btn items-cennter" to="/contact">

                      <TbMathGreater style={{ fontSize: "16px" }} />
                      <span className="footer_link_changes">Contact us</span>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="pt-6 mt-12 border-t border-gray-800">
            <div className="text-center sm:flex sm:justify-between sm:text-left">
              <div className="text-sm text-gray-400">
                <ul className="flex gap-10 list-none">
                  <li>
                    <Link
                      to="https://www.facebook.com/FlyInnLLC/"
                      target="_blank"
                    >
                      <FiFacebook
                        style={{ fontSize: "20px", color: "#4f5962" }}
                      />
                    </Link>
                  </li>
                  <li>
                    <Link to="https://twitter.com/FlyInnLLC" target="_blank">
                      <FiTwitter
                        style={{ fontSize: "20px", color: "#4f5962" }}
                      />
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="https://www.instagram.com/flyinnllc/"
                      target="_blank"
                    >
                      <FaInstagram
                        style={{ fontSize: "20px", color: "#4f5962" }}
                      />
                    </Link>
                  </li>
                  <li>
                    <Link to="https://www.youtube.com/@FLY-INN" target="_blank">
                      <FiYoutube
                        style={{ fontSize: "20px", color: "#4f5962" }}
                      />
                    </Link>
                  </li>
                </ul>
              </div>
              <p className="mt-4 text-sm text-gray-500 sm:order-first sm:mt-0">
                FlyInn LLC - All rights reserved © 2020-2024
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default TailwindFooter;
